import React, { useState, useEffect } from "react";
import { API } from "../../config/api";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./../Styles/login.css";
import { BASE_URL } from "../../config/api";
export default function LoginPage({
  isOpen = true,
  onClose = () => {},
  openRegister = () => {},
}) {
  const [formData, setFormData] = useState({
    mobileno: "",
    password: "",
    rememberme: false,
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  // forgot password
  const [showForgotPopup, setShowForgotPopup] = useState(false);
  const [forgotPhone, setForgotPhone] = useState("");
  const [countryCode, setCountryCode] = useState("91");

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // ================= LOAD REMEMBER =================
  // useEffect(() => {
  //   const savedMobile = localStorage.getItem("mobileno");
  //   const savedPassword = localStorage.getItem("password");

  //   if (savedMobile && savedPassword) {
  //     setFormData({
  //       mobileno: savedMobile,
  //       password: savedPassword,
  //       rememberme: true,
  //     });
  //   }
  // }, []);
  useEffect(() => {
    const savedMobile = localStorage.getItem("mobileno");

    if (savedMobile) {
      setFormData((prev) => ({
        ...prev,
        mobileno: savedMobile,
        rememberme: true,
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ================= LOGIN =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!formData.mobileno.trim()) {
      setError("Mobile number is required");
      return;
    }

    if (!formData.password.trim()) {
      setError("Password is required");
      return;
    }

    const mobile = formData.mobileno.replace(/^0+/, "");

    setLoading(true);

    try {
      const params = new URLSearchParams();
      params.append("MobileNo", mobile);
      params.append("Password", formData.password);

      const res = await fetch(API.LOGIN, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      });

      const result = await res.json();
      const data = result?.data || result;

      // console.log("LOGIN RESPONSE:", data);

      if (!data || data.id == "-1" || data.id == -1) {
        setError("Invalid Mobile No or Password");
        return;
      }

      // const userData = {
      //   id: Number(data.id),
      //   user_login_id: Number(data.id),
      //   name: data.username,
      //   balance: data.balance || 0,
      //   mobileno: mobile,
      // };
      const userData = {
        id: Number(data.id),
        user_login_id: Number(data.id),
        name: data.username,
        email: data.email,
        balance: data.balance || 0,
        mobileno: data.mobileno || mobile,
        token: data.token,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("token", data.token);

      window.dispatchEvent(
        new CustomEvent("userLogin", {
          detail: { user: userData },
        }),
      );
      // console.log("Saving user:", userData);

      localStorage.setItem("user", JSON.stringify(userData));

      // console.log("Stored user:", localStorage.getItem("user"));

      if (formData.rememberme) {
        localStorage.setItem("mobileno", mobile);
        // localStorage.setItem("password", formData.password);
      }

      setShowPopup(true);
    } catch (err) {
      console.error(err);
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  // const sendOtp = async () => {
  //   try {
  //     if (!forgotPhone) {
  //       alert("Enter mobile number");
  //       return;
  //     }

  //     // remove +91
  //     const mobileNumber = forgotPhone
  //       .replace("+91", "")
  //       .replace(/^91/, "")
  //       .replace(/\s/g, "");

  //     const otpValue = Math.floor(100000 + Math.random() * 900000).toString();

  //     console.log("Mobile:", mobileNumber);
  //     console.log("OTP:", otpValue);

  //     // ================= STEP 1 GET USER ID =================

  //     const forgotParams = new URLSearchParams();

  //     forgotParams.append("MobileNo", mobileNumber);
  //     forgotParams.append("otp", otpValue);

  //     const forgotRes = await fetch(API.FORGOT_PASSWORD, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //       body: forgotParams.toString(),
  //     });

  //     const forgotText = await forgotRes.text();

  //     console.log("FORGOT RESPONSE:", forgotText);

  //     let forgotData;

  //     try {
  //       forgotData = JSON.parse(forgotText);
  //     } catch (e) {
  //       alert("Invalid forgot password response");
  //       return;
  //     }

  //     // your PHP returns user_id
  //     const userId =
  //       forgotData.user_id || forgotData.userid || forgotData.data?.id;

  //     console.log("USER ID:", userId);

  //     if (!userId || userId == -1) {
  //       alert(forgotData.message || "Mobile number not registered");
  //       return;
  //     }

  //     // SAVE USER ID

  //     localStorage.setItem("forgot_user_id", String(userId));

  //     console.log("Saved ID:", localStorage.getItem("forgot_user_id"));

  //     // ================= STEP 2 SEND SMS OTP =================

  //     const otpParams = new URLSearchParams();

  //     otpParams.append("mobileno", mobileNumber);
  //     otpParams.append("otp", otpValue);
  //     otpParams.append("code", countryCode);

  //     const otpRes = await fetch(`${BASE_URL}/send_otp.php`, {
  //       method: "POST",

  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },

  //       body: otpParams.toString(),
  //     });

  //     const otpText = await otpRes.text();

  //     console.log("SEND OTP RESPONSE:", otpText);

  //     let otpResult;

  //     try {
  //       otpResult = JSON.parse(otpText);
  //     } catch (e) {
  //       alert("Invalid OTP API response");
  //       return;
  //     }

  //     if (!otpResult.status) {
  //       alert(otpResult.message || "OTP failed");
  //       return;
  //     }

  //     // save otp

  //     localStorage.setItem("forgotOtp", otpValue);

  //     setOtpSent(true);

  //     alert("OTP Sent Successfully");
  //   } catch (error) {
  //     console.error("SEND OTP ERROR:", error);

  //     alert("Server error");
  //   }
  // };
  const sendOtp = async () => {
    try {
      if (!forgotPhone) {
        alert("Enter mobile number");
        return;
      }

      let mobileNumber = forgotPhone
        .replace("+91", "")
        .replace(/\s/g, "")
        .replace(/^91/, "");

      const otpValue = Math.floor(100000 + Math.random() * 900000).toString();

      // console.log("FINAL MOBILE:", mobileNumber);
      // console.log("OTP:", otpValue);

      // ===========================
      // STEP 1: CHECK USER + GET ID
      // ===========================

      const params = new URLSearchParams();

      params.append("MobileNo", mobileNumber);
      params.append("otp", otpValue);

      const res = await fetch(API.FORGOT_PASSWORD, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      });

      const text = await res.text();

      // console.log("FORGET API RAW:", text);

      let data;

      try {
        data = JSON.parse(text);
      } catch (e) {
        alert("Forget password API error");
        return;
      }

      // your PHP response
      const userId =
        data.user_id || data.userid || data.data?.id || data.raw?.data?.id;

      // console.log("USER ID:", userId);

      if (!userId || userId == -1) {
        alert(data.message || "Mobile number not registered");
        return;
      }

      localStorage.setItem("forgot_user_id", userId);

      // ===========================
      // STEP 2 SEND OTP SMS
      // ===========================

      const otpParams = new URLSearchParams();

      otpParams.append("mobileno", mobileNumber);

      otpParams.append("otp", otpValue);

      otpParams.append("code", "91");

      const otpRes = await fetch(`${BASE_URL}/send_otp.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: otpParams.toString(),
      });

      const otpText = await otpRes.text();

      // console.log("SEND OTP RAW:", otpText);

      const otpData = JSON.parse(otpText);

      if (!otpData.status) {
        alert(otpData.message || "OTP failed");
        return;
      }

      localStorage.setItem("forgotOtp", otpValue);

      setOtpSent(true);

      alert("OTP Sent Successfully");
    } catch (err) {
      console.log("SEND OTP ERROR", err);

      alert("Server error");
    }
  };
  // ================= VERIFY OTP =================
  const verifyOtp = () => {
    const savedOtp = localStorage.getItem("forgotOtp");

    if (otp === savedOtp) {
      setOtpVerified(true);
      localStorage.setItem("verifiedOTP", "true");
      alert("OTP Verified");
    } else {
      alert("Invalid OTP");
    }
  };
  const forgotUserId = localStorage.getItem("forgot_user_id");

  // console.log("Changing password for:", forgotUserId);

  // ================= CHANGE PASSWORD =================
  // const changePassword = async () => {
  //   if (!newPassword) {
  //     alert("Enter New Password");
  //     return;
  //   }

  //   if (newPassword !== confirmPassword) {
  //     alert("Passwords do not match");
  //     return;
  //   }

  //   const forgotUserId = localStorage.getItem("forgot_user_id");

  //   if (!forgotUserId) {
  //     alert("User ID not found");
  //     return;
  //   }

  //   console.log("forgotUserId =", forgotUserId);

  //   try {
  //     const params = new URLSearchParams();
  //     params.append("userid", forgotUserId);
  //     params.append("password", newPassword);

  //     const res = await fetch(API.CHANGE_PASSWORD, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //       body: params.toString(),
  //     });

  //     const text = await res.text();

  //     console.log("CHANGE PASSWORD RAW:", text);

  //     let result;

  //     try {
  //       result = JSON.parse(text);
  //     } catch (e) {
  //       console.error(e);
  //       alert("Invalid server response");
  //       return;
  //     }

  //     console.log("CHANGE PASSWORD RESULT:", result);

  //     if (result.status === true || result.success === true) {
  //       alert("Password changed successfully");

  //       setShowForgotPopup(false);
  //       setOtpSent(false);
  //       setOtpVerified(false);

  //       localStorage.removeItem("forgotOtp");
  //       localStorage.removeItem("forgot_user_id");
  //       localStorage.removeItem("verifiedOTP");
  //     } else {
  //       alert(result.message || "Failed to change password");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     alert("Server error");
  //   }
  // };
  // ================= CHANGE PASSWORD =================
  const changePassword = async () => {
    if (!newPassword) {
      alert("Enter New Password");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    // GET USER ID FROM LOCAL STORAGE
    const forgotUserId = localStorage.getItem("forgot_user_id");

    // console.log("Changing password for:", forgotUserId);

    if (!forgotUserId) {
      alert("User ID not found. Please verify OTP again.");
      return;
    }

    try {
      const params = new URLSearchParams();

      params.append("userid", forgotUserId);

      params.append("password", newPassword);

      // console.log("CHANGE PASSWORD DATA:", params.toString());

      const res = await fetch(API.CHANGE_PASSWORD, {
        method: "POST",

        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },

        body: params.toString(),
      });

      const text = await res.text();

      // console.log("CHANGE PASSWORD RAW RESPONSE:", text);

      let result;

      try {
        result = JSON.parse(text);
      } catch (err) {
        console.error("JSON ERROR:", err);

        alert("Invalid server response");

        return;
      }

      // console.log("CHANGE PASSWORD RESULT:", result);

      if (
        result.status === true ||
        result.success === true ||
        result.Status === true
      ) {
        alert("Password changed successfully");

        // close popup
        setShowForgotPopup(false);

        // reset states
        setOtpSent(false);
        setOtpVerified(false);

        setOtp("");
        setNewPassword("");
        setConfirmPassword("");

        // remove forgot data

        localStorage.removeItem("forgotOtp");

        localStorage.removeItem("forgot_user_id");

        localStorage.removeItem("verifiedOTP");
      } else {
        alert(result.message || "Failed to change password");
      }
    } catch (error) {
      console.error("CHANGE PASSWORD ERROR:", error);

      alert("Server error");
    }
  };
  if (!isOpen) return null;

  return (
    <>
      {/* LOGIN POPUP */}
      <div
        className="login-popup-overlay"
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="login-popup-card">
          <button className="login-popup-close" onClick={onClose}>
            ✕
          </button>

          <div className="login-header">
            <h2>Login</h2>
            <p>Sign in to continue</p>
          </div>

          {error && <div className="login-popup-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="login-popup-form-group">
              <label>Mobile Number</label>
              <input
                type="text"
                name="mobileno"
                placeholder="Enter mobile number"
                value={formData.mobileno}
                onChange={handleChange}
                className="login-popup-input"
              />
            </div>

            <div className="login-popup-form-group">
              <label>Password</label>

              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  className="login-popup-input"
                  style={{ paddingRight: "45px" }}
                />

                <i
                  className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#666",
                  }}
                ></i>
              </div>
            </div>

            <div className="login-options">
              <label className="remember-box">
                <input
                  type="checkbox"
                  name="rememberme"
                  checked={formData.rememberme}
                  onChange={handleChange}
                />
                Remember me
              </label>

              <button
                type="button"
                className="forgot-link"
                onClick={() => setShowForgotPopup(true)}
              >
                Forgot Password?
              </button>
            </div>

            {/* FOOTER */}
            <div className="login-popup-footer">
              <p>
                New here?{" "}
                <span
                  className="login-popup-link"
                  onClick={() => {
                    onClose();
                    openRegister();
                  }}
                >
                  Create Account
                </span>
              </p>
            </div>

            <button
              type="submit"
              className="login-popup-btn"
              disabled={loading}
            >
              {loading ? "Please Wait..." : "Login"}
            </button>
          </form>
        </div>
      </div>

      {/* SUCCESS POPUP */}
      {showPopup && (
        <div className="login-popup-overlay">
          <div className="login-popup-card" style={{ textAlign: "center" }}>
            <h3>Login Successful</h3>

            <button
              className="login-popup-btn"
              onClick={() => {
                setShowPopup(false);
                window.location.href = "/";
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* FORGOT PASSWORD */}
      {showForgotPopup && (
        <div className="login-popup-overlay">
          <div className="login-popup-card">
            <button
              className="login-popup-close"
              onClick={() => {
                setShowForgotPopup(false);
                setOtpSent(false);
                setOtpVerified(false);
              }}
            >
              ✕
            </button>

            <div className="login-header">
              <h2>Forgot Password</h2>
              <p>Enter your registered mobile number</p>
            </div>

            {!otpSent && (
              <>
                <div className="login-popup-form-group">
                  <label>Mobile Number</label>

                  <PhoneInput
                    country={"in"}
                    value={forgotPhone}
                    enableSearch={true}
                    onChange={(phone, country) => {
                      setForgotPhone(phone);
                      setCountryCode(country.dialCode);
                    }}
                    inputStyle={{
                      width: "100%",
                      height: "45px",
                    }}
                  />
                </div>

                <button className="login-popup-btn" onClick={sendOtp}>
                  Send OTP
                </button>
              </>
            )}

            {otpSent && !otpVerified && (
              <>
                <div className="login-popup-form-group">
                  <label>Enter OTP</label>

                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="login-popup-input"
                    placeholder="Enter OTP"
                  />
                </div>

                <button className="login-popup-btn" onClick={verifyOtp}>
                  Verify OTP
                </button>
              </>
            )}

            {otpVerified && (
              <>
                {/* NEW PASSWORD */}
                <div className="login-popup-form-group">
                  <label>New Password</label>

                  <div style={{ position: "relative" }}>
                    <input
                      type={showNewPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="login-popup-input"
                      style={{ paddingRight: "45px" }}
                    />

                    <i
                      className={`bi ${showNewPassword ? "bi-eye-slash" : "bi-eye"}`}
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#666",
                      }}
                    />
                    {/* <i
                      className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#666",
                      }}
                    /> */}
                  </div>
                </div>

                {/* CONFIRM PASSWORD */}
                <div className="login-popup-form-group">
                  <label>Confirm Password</label>

                  <div style={{ position: "relative" }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="login-popup-input"
                      style={{ paddingRight: "45px" }}
                    />

                    <i
                      className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"}`}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#666",
                      }}
                    />
                    {/* <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Confirm Password"
                      value={confirmPassword} // ✅ FIXED
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className="login-popup-input"
                      style={{ paddingRight: "45px" }}

                    />

                    <i
                      className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "15px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "#666",
                      }}
                    /> */}
                  </div>
                </div>

                <button className="login-popup-btn" onClick={changePassword}>
                  Change Password
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
